import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export default function ForgotPassword() {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]       = useState('');
  const [resetUrl, setResetUrl] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSubmitted(true);
      // Dev/admin mode: backend returns the reset link directly when no SMTP is configured
      if (res.data.resetUrl) {
        setResetUrl(res.data.resetUrl);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        {/* Logo */}
        <div className="text-center mb-4">
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 52, height: 52, borderRadius: 13,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            fontSize: 26, fontWeight: 900, color: '#fff', marginBottom: 12,
            boxShadow: '0 8px 24px rgba(99,102,241,.4)',
          }}>Z</div>
          <h2 style={{ color: '#fff', fontWeight: 800, margin: 0 }}>Forgot Password</h2>
          <p style={{ color: '#94a3b8', marginTop: 4, fontSize: 14 }}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        <div style={{ background: '#fff', borderRadius: 18, padding: '2rem', boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
          {!submitted ? (
            <>
              {error && (
                <div className="alert alert-danger d-flex align-items-center gap-2 py-2" style={{ fontSize: 14 }}>
                  <span>⚠️</span> {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label fw-semibold">Email Address</label>
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="your@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  className="btn w-100 fw-semibold"
                  disabled={loading}
                  style={{
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    color: '#fff', padding: '12px', fontSize: 15, borderRadius: 10,
                  }}
                >
                  {loading
                    ? <><span className="spinner-border spinner-border-sm me-2" />Sending…</>
                    : '📧 Send Reset Link'}
                </button>
              </form>
            </>
          ) : (
            <div className="text-center">
              <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
              <h5 className="fw-bold mb-2">Check your inbox</h5>
              <p className="text-muted" style={{ fontSize: 14 }}>
                If <strong>{email}</strong> is registered, you'll receive a reset link shortly.
              </p>

              {/* Dev/admin mode: show the link directly when no SMTP is configured */}
              {resetUrl && (
                <div className="alert alert-warning mt-3 text-start" style={{ fontSize: 13 }}>
                  <strong>⚠️ No email service configured.</strong> Share this link with the user:
                  <div className="mt-2 p-2 rounded" style={{ background: '#f8f9fa', wordBreak: 'break-all' }}>
                    <a href={resetUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>{resetUrl}</a>
                  </div>
                  <div className="mt-1" style={{ color: '#6c757d', fontSize: 12 }}>
                    This link expires in 1 hour. Configure <code>SMTP_HOST</code> to enable email delivery.
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="text-center mt-3">
            <Link to="/login" style={{ color: '#6366f1', fontSize: 14, textDecoration: 'none' }}>
              ← Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
